function LoadingBar({ className }: { className: string }) {
  return <div className={`bg-neutral-950/8 ${className}`} aria-hidden="true" />;
}

function LoadingCard({
  titleWidth,
  descriptionWidth,
  lines,
}: {
  titleWidth: string;
  descriptionWidth: string;
  lines: string[];
}) {
  return (
    <section className="border-[3px] border-neutral-950 bg-[#fffaf1] p-5 shadow-[10px_10px_0_rgba(19,19,19,0.12)]">
      <div className="space-y-3">
        <LoadingBar className={`h-5 ${titleWidth}`} />
        <LoadingBar className={`h-3 ${descriptionWidth}`} />
      </div>
      <div className="mt-6 space-y-3">
        {lines.map((width, index) => (
          <LoadingBar key={`${width}-${index}`} className={`h-11 ${width}`} />
        ))}
      </div>
    </section>
  );
}

export default function AdminLoading() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading admin workspace"
      className="animate-pulse grid gap-6 xl:grid-cols-[320px_minmax(0,1fr)]"
    >
      <div className="space-y-6">
        <LoadingCard
          titleWidth="w-36"
          descriptionWidth="w-56"
          lines={["w-full", "w-full", "w-4/5", "w-2/3"]}
        />
        <LoadingCard titleWidth="w-28" descriptionWidth="w-44" lines={["w-full", "w-5/6", "w-3/4"]} />
      </div>
      <LoadingCard
        titleWidth="w-40"
        descriptionWidth="w-64"
        lines={["w-full", "w-full", "w-full", "w-11/12", "w-5/6", "w-4/5"]}
      />
    </div>
  );
}
